import React from 'react';
import './ZoomControls.css';

const ZoomControls = React.memo(({ onZoomIn, onZoomOut, onResetView }) => {
  return (
    <div className="zoom-controls">
      <button onClick={onZoomIn} title="Zoom In" aria-label="Zoom In">
        +
      </button>
      <button onClick={onZoomOut} title="Zoom Out" aria-label="Zoom Out">
        −
      </button>
      <button onClick={onResetView} title="Reset View" aria-label="Reset View">
        ⊙
      </button>
    </div>
  );
});

ZoomControls.displayName = 'ZoomControls';

export default ZoomControls;

